interface IColors {
  primary: string;
}

interface ISizes {
  normal: number;
  xxl: number;
}

export const COLORS: IColors = {
  primary: '#efefef',
};

export const SIZES: ISizes = {
  normal: 12,
  xxl: 40,
};
